// extracted by mini-css-extract-plugin
export default {"wrap":"StickyFiles_wrap__xSOk+","container":"StickyFiles_container__3Hpi1","item":"StickyFiles_item__5V5nb"};